module.exports = __webpack_public_path__ + "img/hands-helping.4bd5a6fc.svg";